import React from 'react';

const AgendaDisplayPage = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8 w-full h-full">
      <iframe 
        src="https://calendar.google.com/calendar/embed?src=adiboo67%40gmail.com&ctz=Europe%2FBrussels" 
        style={{ border: 0, width: '100%', height: 'calc(100vh - 200px)' }} 
        frameBorder="0" 
        scrolling="no"
        title="Google Calendar Embed"
      ></iframe>
    </div>
  );
};

export default AgendaDisplayPage; 